import * as React from 'react';
import { Outlet } from '@tanstack/react-router';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { cn } from '@/lib/utils';
import { SkipLink } from '@/components/accessibility/SkipLink';

export function AppShell(): React.JSX.Element {
  const [sidebarCollapsed, setSidebarCollapsed] = React.useState(false);

  // Load sidebar state from localStorage
  React.useEffect(() => {
    const stored = localStorage.getItem('sidebar-collapsed');
    if (stored !== null) {
      setSidebarCollapsed(stored === 'true');
    }
  }, []);

  const handleSidebarToggle = () => {
    const newState = !sidebarCollapsed;
    setSidebarCollapsed(newState);
    localStorage.setItem('sidebar-collapsed', String(newState));
  };

  return (
    <div className="min-h-screen bg-background">
      <SkipLink targetId="main-content" />
      <Sidebar collapsed={sidebarCollapsed} onToggle={handleSidebarToggle} />
      <Header sidebarCollapsed={sidebarCollapsed} />

      <main
        id="main-content"
        role="main"
        tabIndex={-1}
        className={cn(
          'min-h-screen pt-16 transition-all duration-300 focus:outline-none',
          sidebarCollapsed ? 'pl-16' : 'pl-64'
        )}
      >
        <div className="p-6">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
